<div class="modal-header">
  <h4 class="modal-title">{{ getModalTitle() }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="currentStep === 1" class="step-container">
    <!-- <div (click)="downloadExampleCSV()" class="example-csv-container">

      {{ 'pages.stock.bulkUpload.downloadCSVExample' | translate }}
    </div> -->

    <form [formGroup]="uploadForm" class="upload-form">
      <div class="form-group">
        <label for="productCategory" class="form-label required">
          {{ 'pages.stock.bulkUpload.productCategory' | translate }}
        </label>
        <select id="productCategory" formControlName="productCategoryId" class="form-control"
          [class.disabled]="isPredefinedCategory" [disabled]="isPredefinedCategory">
          <option value="" disabled>{{ 'pages.stock.bulkUpload.selectCategory' | translate }}</option>
          <option *ngFor="let category of productCategories" [value]="category.productCategoryId">
            {{ category.productCategoryCode }}
          </option>
        </select>
        <div
          *ngIf="uploadForm.get('productCategoryId')?.invalid && uploadForm.get('productCategoryId')?.touched && !isPredefinedCategory"
          class="error-message">
          {{ 'pages.stock.bulkUpload.categoryRequired' | translate }}
        </div>

        <!-- Closing overlay shown while waiting before auto-close -->
        <div class="bulk-upload-closing-overlay" *ngIf="isClosingDelay">
          <div class="bulk-upload-closing-overlay__content">
            <div class="bulk-upload-loader" aria-hidden="true"></div>
            <div class="bulk-upload-message">{{ 'pages.stock.bulkUpload.backgroundStarted' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isGroupAdmin && !isPredefinedStore" data-testid="bulk-upload-center-group">
        <label for="center" class="form-label required">
          {{ 'pages.stock.bulkUpload.center' | translate }}
        </label>
        <select id="center" formControlName="centerId" class="form-control"
          data-testid="bulk-upload-center-select">
          <option [ngValue]="null" disabled>
            {{ 'pages.stock.bulkUpload.selectCenter' | translate }}
          </option>
          <option *ngFor="let center of centers" [ngValue]="center.id">
            {{ center.name }}
          </option>
        </select>
        <div *ngIf="uploadForm.get('centerId')?.invalid && uploadForm.get('centerId')?.touched"
          class="error-message">
          {{ 'pages.stock.bulkUpload.centerRequired' | translate }}
        </div>
      </div>

      <div class="form-group" *ngIf="!isPredefinedStore">
        <label for="store" class="form-label required">
          {{ 'pages.stock.bulkUpload.store' | translate }}
        </label>
        <select id="store" formControlName="storeId" class="form-control"
          data-testid="bulk-upload-store-select">
          <option value="" disabled>
            <ng-container *ngIf="!isLoadingStores; else loadingStores">
              {{ 'pages.stock.bulkUpload.selectStore' | translate }}
            </ng-container>
            <ng-template #loadingStores>{{ 'common.loading' | translate }}</ng-template>
          </option>
          <option *ngFor="let store of stores" [value]="store.id">
            {{ store.name }}
          </option>
        </select>
        <div *ngIf="uploadForm.get('storeId')?.invalid && uploadForm.get('storeId')?.touched"
          class="error-message">
          {{ 'pages.stock.bulkUpload.storeRequired' | translate }}
        </div>
      </div>

      <div class="form-group form-group--replace-stock"
        *ngIf="(uploadForm.get('storeId')?.value || isPredefinedStore)"
        data-testid="bulk-upload-replace-stock-group">
        <label class="replace-stock-toggle">
          <input type="checkbox" formControlName="replaceStock"
            data-testid="bulk-upload-replace-stock" />
          <span class="replace-stock-toggle__text">
            {{ 'pages.stock.bulkUpload.replaceStock.label' | translate }}
          </span>
        </label>
        <p class="replace-stock-toggle__help">
          {{ 'pages.stock.bulkUpload.replaceStock.help' | translate }}
        </p>
      </div>
      <div class="form-group" *ngIf="isPredefinedStore">
        <label class="form-label required">
          {{ 'pages.stock.bulkUpload.store' | translate }}
        </label>
        <div class="read-only-input">{{ predefinedStoreName }}</div>
      </div>
      <div class="file-upload-section">
        <div class="file-upload-container">
          <input type="file" id="csvFile" accept=".csv,.xlsx,.xls" (change)="onFileSelected($event)" class="file-input" #fileInput>

          <div class="upload-button-container">
            <button type="button" class="upload-file-btn" (click)="fileInput.click()">
              {{ 'pages.stock.bulkUpload.uploadFile' | translate }}
            </button>
          </div>

          <div class="load-button-container">
            <button type="button" class="btn-load-file" [disabled]="!canProceedToStep2()" (click)="proceedToStep2()">
              {{ 'pages.stock.bulkUpload.loadFile' | translate }}
            </button>
          </div>

          <div *ngIf="selectedFile" class="file-info">
            <span class="file-name">{{ selectedFile.name }}</span>
            <span *ngIf="isMappingReady" class="file-info__mapping-ready"
              data-testid="bulk-upload-mapping-ready">
              ✓ {{ 'pages.stock.bulkUpload.columnMapping.mappingReady' | translate }}
            </span>
            <button type="button" class="remove-file-btn" (click)="removeFile()">×</button>
          </div>
        </div>
        <div *ngIf="fileError" class="error-message">
          {{ fileError }}
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="currentStep === 2" class="step-container">
    <div class="upload-summary">
      <h5 class="details-title">{{ 'pages.stock.bulkUpload.uploadDetails' | translate }}</h5>

      <div class="summary-info">
        <div class="info-item">
          <div class="info-label">{{ 'pages.stock.bulkUpload.totalProducts' | translate }}</div>
          <div class="info-value">{{ parsedProducts.length }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ 'pages.stock.bulkUpload.productCategory' | translate }}</div>
          <div class="info-value">{{ getSelectedCategoryName() }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ 'pages.stock.bulkUpload.store' | translate }}</div>
          <div class="info-value">{{ getSelectedStoreName() }}</div>
        </div>
      </div>
      <div class="products-summary">
        <div class="summary-badge create" *ngIf="getProductsToCreate() > 0">
          <span class="count">{{ getProductsToCreate() }}</span>
          <span class="text">{{ 'pages.stock.bulkUpload.productsWillBeCreated' | translate }}</span>
        </div>

        <div class="summary-badge update" *ngIf="getProductsToUpdate() > 0">
          <span class="count">{{ getProductsToUpdate() }}</span>
          <span class="text">{{ 'pages.stock.bulkUpload.productsWillBeUpdated' | translate }}</span>
        </div>

        <div class="file-name-info">
          <span class="file-label">{{ 'pages.stock.bulkUpload.fileName' | translate }}:</span>
          <span class="file-name">{{ selectedFile?.name }}</span>
        </div>
      </div>

      <div class="processing-stats">
        <div class="stats-info">
          <div class="stat-item">
            <div class="stat-label">{{ 'pages.stock.bulkUpload.processedRows' | translate }}</div>
            <div class="stat-value success">{{ previewResponse?.processedRows || 0 }}</div>
          </div>
          <div class="stat-item" *ngIf="(previewResponse?.failedRows || 0) > 0">
            <div class="stat-label">{{ 'pages.stock.bulkUpload.failedRows' | translate }}</div>
            <div class="stat-value error">{{ previewResponse?.failedRows || 0 }}</div>
          </div>
        </div>

        <div class="failed-rows-warning" *ngIf="hasBlockingValidationErrors">
          <div class="warning-icon">⚠️</div>
          <div class="warning-content">
            <div class="warning-title">{{ 'pages.stock.bulkUpload.validationErrorsTitle' | translate }}</div>
            <div class="warning-message">
              {{ 'pages.stock.bulkUpload.validationErrorsMessage' | translate: {count: blockingValidationErrorsCount} }}
            </div>
          </div>
        </div>

        <div class="failed-rows-warning" *ngIf="(previewResponse?.failedRows || 0) > 0">
          <div class="warning-icon">⚠️</div>
          <div class="warning-content">
            <div class="warning-title">{{ 'pages.stock.bulkUpload.failedRowsWarning' | translate }}</div>
            <div class="warning-message">
              {{ 'pages.stock.bulkUpload.failedRowsMessage' | translate: {count: previewResponse?.failedRows} }}
            </div>
            <div class="failed-rows-list"
              *ngIf="previewResponse?.failedRowNumbers && (previewResponse?.failedRowNumbers?.length || 0) > 0">
              <strong>{{ 'pages.stock.bulkUpload.failedRowNumbers' | translate }}:</strong>
              <span class="row-numbers">{{ getFailedRowsText() }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="products-table-simple">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'pages.stock.bulkUpload.table.code' | translate }}</th>
              <th>{{ 'pages.stock.bulkUpload.table.quantity' | translate }}</th>
              <th>{{ 'pages.stock.bulkUpload.table.internalRef' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of parsedProducts">
              <td>{{ product.code }}</td>
              <td>{{ product.quantity }}</td>
              <td class="internal-ref-cell">
                <span *ngIf="product.internalReference && product.internalReference.trim(); else autoGenerate">{{
                  product.internalReference }}</span>
                <ng-template #autoGenerate>
                  <span class="auto-generate-text">{{ 'pages.stock.bulkUpload.table.autoGenerateOnSave' | translate
                    }}</span>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="validation-panels" *ngIf="previewResponse?.validationErrors">
        <div class="validation-panel" *ngIf="(previewResponse?.validationErrors?.missingDataRows || []).length > 0">
          <div class="panel-title">{{ 'pages.stock.bulkUpload.results.missingDataSection' | translate }}</div>
          <ul>
            <li *ngFor="let row of previewResponse?.validationErrors?.missingDataRows | slice:0:8">
              #{{ row.rowNumber }} — {{ row.missingFields.join(', ') }}
            </li>
          </ul>
        </div>

        <div class="validation-panel" *ngIf="(previewResponse?.validationErrors?.duplicateRows || []).length > 0">
          <div class="panel-title">{{ 'pages.stock.bulkUpload.results.duplicatesSection' | translate }}</div>
          <ul>
            <li *ngFor="let row of previewResponse?.validationErrors?.duplicateRows | slice:0:8">
              #{{ row.rowNumber }} — {{ row.code }}
            </li>
          </ul>
        </div>

        <div class="validation-panel" *ngIf="(previewResponse?.validationErrors?.consolidatedRows || []).length > 0">
          <div class="panel-title">{{ 'pages.stock.bulkUpload.results.consolidationsSection' | translate }}</div>
          <ul>
            <li *ngFor="let row of previewResponse?.validationErrors?.consolidatedRows | slice:0:8">
              {{ row.code }} — {{ row.rowNumbers.join(', ') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="isProcessing" class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'pages.stock.bulkUpload.processing' | translate }}</p>
  </div>

  <div *ngIf="isPreparingResults" class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'pages.stock.bulkUpload.preparingResults' | translate }}</p>
  </div>
</div>

<div class="modal-footer">
  <ng-container *ngIf="currentStep === 2">
    <button type="button" class="btn btn-secondary" (click)="goBackToStep1()">
      {{ 'common.back' | translate }}
    </button>
    <button type="button" class="btn btn-primary confirm-btn"
      [disabled]="isProcessing || hasBlockingValidationErrors || isClosingDelay" (click)="confirmUpload()">
      <span class="button-spinner" *ngIf="isClosingDelay" aria-hidden="true"></span>
      {{ 'pages.stock.bulkUpload.confirmAndUpload' | translate }}
    </button>
  </ng-container>
</div>